"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-seven/sections/workSection.tsx */

import { SmartImage } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type WorkSection36FadeInUpsItem = {
    key: Key | null | undefined;
    /** Detected variants: "1s" | "2s" | "3s" | "4s" */
    dataWowDuration: string;
    /** Detected variants: "/Templates/Doccure/img/icons/work-01.svg" | "/Templates/Doccure/img/icons/work-02.svg" | "/Templates/Doccure/img/icons/work-03.svg" | "/Templates/Doccure/img/icons/work-04.svg" */
    src: string;
    /** Detected variants: "01" | "02" | "03" | "04" */
    div1Text: ReactNode;
    /** Detected variants: "Compassionate Care & Treatments" | "Quick Results & Reports" | "Latest Diagnostic Technology" | "Affordable Packages For Checkups" */
    h30Text: ReactNode;
    /** Detected variants: "Patient-centered approach with personalized attention" | "Fast turnaround time for all diagnostic tests" | "State of the art equipment for accurate diagnosis" | "Transparent pricing with flexible payment options" */
    p0Text: ReactNode;
    /** Detected variants: "col-xl-3 col-md-6 d-flex wow fadeInUp" */
    className?: string;
    /** Detected variants: "0.2s" */
    dataWowDelay?: string;
    /** Detected variants: "work-item-two flex-fill" */
    div0ClassName?: string;
    /** Detected variants: "work-info" */
    div0ClassName2?: string;
    /** Detected variants: "work-icon" */
    div0ClassName3?: string;
    /** Detected variants: "icon" */
    alt?: string;
    /** Detected variants: "img-fluid" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "count-number" */
    div1ClassName?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
};
export type HomeSevenWorkSectionGeneratedProps = {
    divDiv0Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: WorkSection36FadeInUpsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0H30H3Props?: Partial<ComponentProps<"h3">> | ((item: WorkSection36FadeInUpsItem) => Partial<ComponentProps<"h3">>);
    sectionDiv0Div0ClassName?: string;
    /** Default: "Trusted Heart Care Since 2003" */
    sectionDiv0Div0Div0Div0Div0DivText?: ReactNode;
    /** Default: "We combine advanced medical technology with compassionate care to" */
    sectionDiv0Div0Div0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0Div0Div0H20H2Visible?: boolean;
    sectionDiv0Div0Div0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "deliver cardiac healthcare" */
    sectionDiv0Div0Div0Div0H20Span0SpanText?: ReactNode;
    sectionDiv0Div1ClassName?: string;
    /** Default: "Consult top doctors online for any health concern" */
    sectionDiv0Div2Div0DivText?: ReactNode;
    /** Default: "Connect within 60secs" */
    sectionDiv0Div2Div0Span0SpanText?: ReactNode;
    workSection36FadeInUps: WorkSection36FadeInUpsItem[];
    workSection36FadeInUpsItemWrapper?: (item: WorkSection36FadeInUpsItem, content: ReactNode) => ReactNode;
    workSection36FadeInUpsRenderer?: (defaultNode: ReactNode) => ReactNode;
    workSection36FadeInUpsImageVisible?: boolean;
    workSection36FadeInUpsImageRenderer?: (item: WorkSection36FadeInUpsItem, defaultNode: ReactNode) => ReactNode;
    workSection36FadeInUpsH3Visible?: boolean;
    workSection36FadeInUpsH3Renderer?: (item: WorkSection36FadeInUpsItem, defaultNode: ReactNode) => ReactNode;
    workSection36FadeInUpsImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: WorkSection36FadeInUpsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    workSection36FadeInUpsH3Props?: Partial<ComponentProps<"h3">> | ((item: WorkSection36FadeInUpsItem) => Partial<ComponentProps<"h3">>);
};

const HomeSevenWorkSectionGenerated: FC<HomeSevenWorkSectionGeneratedProps> = ({
    sectionDiv0Div0Div0Div0Div0DivText = "Trusted Heart Care Since 2003",
    sectionDiv0Div0Div0Div0H20H2Text = "We combine advanced medical technology with compassionate care to",
    sectionDiv0Div0Div0Div0H20H2Visible,
    sectionDiv0Div0Div0Div0H20H2Renderer,
    sectionDiv0Div0Div0Div0H20H2Props,
    sectionDiv0Div0Div0Div0H20Span0SpanText = "deliver cardiac healthcare",
    sectionDiv0Div2Div0DivText = "Consult top doctors online for any health concern",
    sectionDiv0Div2Div0Span0SpanText = "Connect within 60secs",
    divDiv0Div0Div0ImageWithBasePath0ImageProps,
    divDiv0H30H3Props,
    sectionDiv0Div0ClassName,
    sectionDiv0Div1ClassName,
    workSection36FadeInUps,
    workSection36FadeInUpsItemWrapper,
    workSection36FadeInUpsRenderer,
    workSection36FadeInUpsImageVisible,
    workSection36FadeInUpsImageRenderer,
    workSection36FadeInUpsH3Visible,
    workSection36FadeInUpsH3Renderer,
    workSection36FadeInUpsImageProps,
    workSection36FadeInUpsH3Props,
}) => {
    return (
        <section className="work-section-seven section">
            <div className="container">
                <div className={sectionDiv0Div0ClassName ?? "row"}>
                    <div className="col-xxl-10 col-lg-11 mx-auto">
                        <div className="section-header section-header-seven text-center">
                            <div className="section-sub-title">{sectionDiv0Div0Div0Div0Div0DivText}</div>
                            {renderNode(sectionDiv0Div0Div0Div0H20H2Visible, sectionDiv0Div0Div0Div0H20H2Renderer, (
                                <h2 className="section-title" {...(sectionDiv0Div0Div0Div0H20H2Props ?? {})}>
                                    {sectionDiv0Div0Div0Div0H20H2Text}
                                    {" "}
                                    <span>{sectionDiv0Div0Div0Div0H20Span0SpanText}</span>
                                </h2>
                            ))}
                        </div>
                    </div>
                </div>
                <div className={sectionDiv0Div1ClassName ?? "row g-4"}>
                    {renderCollectionNode(
                        workSection36FadeInUps,
                        (item: WorkSection36FadeInUpsItem) => (
                            <div className={item.className ?? "col-xl-3 col-md-6 d-flex wow fadeInUp"} data-wow-delay={item.dataWowDelay ?? "0.2s"} data-wow-duration={item.dataWowDuration} key={item.key}>
                                <div className={item.div0ClassName ?? "work-item-two flex-fill"}>
                                    {renderItemNode(workSection36FadeInUpsH3Visible, workSection36FadeInUpsH3Renderer, item, (
                                        <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof workSection36FadeInUpsH3Props === "function" ? workSection36FadeInUpsH3Props(item) : (workSection36FadeInUpsH3Props ?? {}))} {...(typeof divDiv0H30H3Props === "function" ? divDiv0H30H3Props(item) : (divDiv0H30H3Props ?? {}))}>{item.h30Text}</h3>
                                    ))}
                                    <div className={item.div0ClassName2 ?? "work-info"}>
                                        <div className={item.div0ClassName3 ?? "work-icon"}>
                                            {renderItemNode(workSection36FadeInUpsImageVisible, workSection36FadeInUpsImageRenderer, item, (
                                                <SmartImage src={item.src} alt={item.alt ?? "icon"} className={item.imageWithBasePath0ClassName ?? "img-fluid"} {...(typeof workSection36FadeInUpsImageProps === "function" ? workSection36FadeInUpsImageProps(item) : (workSection36FadeInUpsImageProps ?? {}))} {...(typeof divDiv0Div0Div0ImageWithBasePath0ImageProps === "function" ? divDiv0Div0Div0ImageWithBasePath0ImageProps(item) : (divDiv0Div0Div0ImageWithBasePath0ImageProps ?? {}))} />
                                            ))}
                                        </div>
                                        <div className={item.div1ClassName ?? "count-number"}>{item.div1Text}</div>
                                    </div>
                                    <p>{item.p0Text}</p>
                                </div>
                            </div>
                        ),
                        workSection36FadeInUpsItemWrapper,
                        workSection36FadeInUpsRenderer
                    )}
                </div>
                <div className="text-center">
                    <div className="connect-badge">
                        {sectionDiv0Div2Div0DivText}
                        {" "}
                        <span>{sectionDiv0Div2Div0Span0SpanText}</span>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HomeSevenWorkSectionGenerated;
